var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-05-25
 * @brief EHP Status 컴포넌트
 *
 ********************************************************************/
import React, { useEffect, useState, useRef } from "react";
// recoli & state
import { useRecoilState, useRecoilValue, useSetRecoilState, useResetRecoilState } from "recoil";
import { userInfoLoginState, } from '../../../recoil/userState';
import { itemState, checkStep, tempCheckValue, assessmentListState } from '../../../recoil/assessmentState';
//
//utils
import clog from "../../../utils/logUtils";
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
/**
 * @brief EHP Status 컴포넌트, 반응형 동작
 * @param param0 width:<number>: 화면(브라우저) 가로 사이즈
 * @param param1 height:<number>: 화면(브라우저) 세로 사이즈
 * @returns react components
 */
function EhcCheckLast(props) {
    // ref
    const mobileRef = useRef(null); // Mobile Check용
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const curItem = useRecoilValue(itemState);
    //const curCheckStep = useRecoilValue(checkStep);
    //const setRecoilCurCheckStep = useSetRecoilState(checkStep);
    const [curCheckStep, setRecoilCurCheckStep] = useRecoilState(checkStep);
    const setRecoilTempCheckVal = useSetRecoilState(tempCheckValue);
    const [itemCheckList, setRecoilItemCheckList] = useRecoilState(assessmentListState);
    const resetRecoilItemCheckList = useResetRecoilState(assessmentListState);
    const resetRecoilTempCheckVal = useResetRecoilState(tempCheckValue);
    //props
    const setParentStatusReload = props.setStatusReload;
    //
    const [totComment, setTotComment] = useState("");
    const [savedFiles, setSavedFiles] = useState([]);
    const [ehpPicture, setEhpPicture] = useState(null);
    const [popupToggle, setPopupToggle] = useState("");
    //mobile by hjoh 20220829 - mobile pop 추가
    const [isMobile, setIsMobile] = useState(false);
    const [imgListCount, setImgListCount] = useState(3);
    useEffect(() => {
        // Mobile 체크
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if (!CUTIL.isnull(mobileTag)) {
                clog("ECHECK LAST : WSIZE : " + mobileTag.clientWidth + " : IMG CNT : " + Math.ceil(mobileTag.clientWidth / 176));
                if (window.innerWidth <= 900) {
                    setIsMobile(true);
                }
                else {
                    setIsMobile(false);
                }
                setImgListCount(Math.ceil(mobileTag.clientWidth / 176));
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    // isMobile 여부 랜더링 후 확인
    /*
    useDebounceEffect(
      async () => {
        if (mobileRef.current) {
          if ((mobileRef.current.clientHeight <= 0) && (mobileRef.current.clientWidth <= 0)) {
            setParentIsMobile(true);
          }
        }
      }, 100, [ehcList],
    )
    */
    //
    const fileRef = useRef();
    // clog("IN BASIC : curPage : " + curPage);
    /*
    useEffect(() => {
      setAssessmentId(srcAssessmentId);
    }, [srcAssessmentId]);
    */
    //첨부파일 
    useEffect(() => {
        if (!CUTIL.isnull(curItem.assessment.assessmentId)) {
            getSavedFiles(curItem.assessment.assessmentId);
        }
    }, [curItem]);
    function doSaveItemCheck(item) {
        return __awaiter(this, void 0, void 0, function* () {
            clog("IN EHCLAST : doSaveItemCheck : " + JSON.stringify(item));
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": "/api/v2/assessment/value/totalComment",
                appQuery: {
                    itemId: item.itemId,
                    stepName: item.ehcType,
                    assessmentId: item.assessment.assessmentId,
                    isTempSave: false,
                    versionNo: itemCheckList[0].versionNo,
                    totalComment: totComment
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    clog("IN CHECK ITEM LAST : getSavedFiles : " + JSON.stringify(data.body));
                    var inputData = {
                        item: item,
                        checkVal: {
                            assessmentId: -1,
                            checkItemId: -1,
                            checkItemName: "",
                            isChecked: false,
                            value: "",
                            valueType: "",
                            comment: "",
                            versionNo: ""
                        },
                        stepDone: true
                    };
                    setRecoilTempCheckVal(inputData);
                    setParentStatusReload(true);
                    //resetRecoilTempCheckVal();
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    function getSavedFiles(assessmentId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "GET",
                "appPath": "/api/v2/assessment/images",
                appQuery: {
                    assessmentId: assessmentId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    clog("IN CHECK ITEM LAST : getSavedFiles : " + JSON.stringify(data.body));
                    setSavedFiles(data.body);
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    function onClickDoSaveEhcCheckResult(item) {
        clog("IN UPLOAD : " + savedFiles.length);
        savedFiles.map((file, idx) => {
            if (file.hasOwnProperty("type") && (file.type == "INS")) {
                saveAttachFiles(item.assessment.assessmentId, file.fileForm);
            }
        });
        //setSaveTotalComment(item);
        doSaveItemCheck(item);
    }
    function saveAttachFiles(assessmentId, fileFormData) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/assessment/images?assessmentId=${assessmentId}`,
                appQuery: fileFormData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    clog("IN CHECK ITEM LAST : saveFiles : " + JSON.stringify(data));
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    function deleteAttachFiles(imgId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HttpUtil.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": "/api/v2/assessment/images",
                appQuery: {
                    imageIds: imgId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    clog("IN CHECK ITEM LAST : saveFiles : " + JSON.stringify(data));
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    function onClickBeforeStep(stepVal) {
        setRecoilCurCheckStep(stepVal - 1);
    }
    function handleFileUpload(e) {
        fileRef.current.click();
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        // clog("save attach file : " + JSON.stringify(e.target.files[0]));
        const formData = new FormData();
        formData.append("files", e.target.files[0]);
        var fileVal = {
            imageId: "INS_" + savedFiles.length,
            name: "temp",
            url: URL.createObjectURL(e.target.files[0]),
            type: "INS",
            fileForm: formData,
        };
        if (savedFiles.length <= 9) {
            setSavedFiles([...savedFiles, fileVal]);
            e.target.value = ''; // file name 초기화
        }
        else {
            alert("첨부파일은 10개 까지 가능합니다.");
        }
    }
    ;
    function onClickAttachFileDelete(delFile) {
        //var delFile = savedFiles[idx];
        if (!delFile.hasOwnProperty("type")) {
            URL.revokeObjectURL(delFile.url);
            deleteAttachFiles(delFile.imageId);
        }
        setSavedFiles(savedFiles.filter(file => file.imageId !== delFile.imageId));
        setEhpPicture(null);
    }
    function onClickEhpPicture(selImg) {
        clog("TOGGLE : " + popupToggle);
        setPopupToggle((popupToggle == "on") ? "" : "on");
        setEhpPicture(selImg);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ehc__detail", ref: mobileRef },
            React.createElement("p", { className: "tit" }, "\uC815\uC131\uD3C9\uAC00"),
            React.createElement("div", { className: "ehc__memo" },
                React.createElement("p", { className: "txtnum" },
                    totComment.length,
                    " / 1,000"),
                React.createElement("textarea", { placeholder: "\uC758\uACAC\uC744 \uC785\uB825\uD558\uC138\uC694.", value: totComment, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 1000), onKeyUp: (e) => CUTIL.afterHandleComment(e, 1000, setTotComment), onChange: (e) => setTotComment(e.target.value) }),
                React.createElement("p", { className: "memo__txt" }))),
        React.createElement("div", { className: "ehc__addfile" },
            React.createElement("p", { className: "tit" }, "\uCCA8\uBD80\uD30C\uC77C"),
            React.createElement("p", { className: "txt" }, "* \uCCA8\uBD80\uD30C\uC77C\uC740 10\uAC1C \uC774\uD558, \uC804\uCCB4 120M\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4"),
            (isMobile)
                ? React.createElement("button", { type: "button", className: "btn btn-photo js-open-s", "data-pop": "pop-fileadd", onClick: (e) => CUTIL.jsopen_s_Popup(e, isMobile) },
                    React.createElement("span", null, "\uD30C\uC77C \uCD94\uAC00"))
                : React.createElement("button", { type: "button", className: "btn btn-photo", onClick: handleFileUpload },
                    React.createElement("span", null, "\uD30C\uC77C \uCD94\uAC00")),
            React.createElement("input", { type: "file", ref: fileRef, accept: "image/jpg, image/jpeg, image/png", multiple: true, style: { display: "none" }, onChange: (e) => saveFileImage(e) })),
        React.createElement("p", { className: "txtnum" },
            savedFiles.length,
            " / 10"),
        React.createElement(EhcPicture, { viewCount: imgListCount, savedFiles: savedFiles, onClickAttachFileDelete: onClickAttachFileDelete, onClickEhpPicture: onClickEhpPicture }),
        React.createElement("div", { className: "tbl__bottom" },
            React.createElement("div", { className: "btn__wrap" },
                (curCheckStep > 0)
                    ? React.createElement("button", { type: "button", className: "bg-transparent", onClick: (e) => onClickBeforeStep(curCheckStep) },
                        React.createElement("span", null, "\uC774\uC804"))
                    : React.createElement("button", { type: "button", className: "bg-transparent" },
                        React.createElement("span", null, "\uC774\uC804")),
                React.createElement("button", { type: "button", onClick: (e) => onClickDoSaveEhcCheckResult(curItem) },
                    React.createElement("span", null, "\uACB0\uACFC \uD655\uC778")))),
        (ehpPicture) && React.createElement(PopupPhotoCloseUp, { popupToggle: popupToggle, setPopupToggle: setPopupToggle, img: ehpPicture, handleFileDelete: onClickAttachFileDelete }),
        React.createElement(FiledPop, { savedFiles: savedFiles, setSavedFiles: setSavedFiles })));
}
export default EhcCheckLast;
function PopupPhotoCloseUp(props) {
    const setParentFileDelete = props.handleFileDelete;
    const img = props.img;
    const toggleVal = props.popupToggle;
    const setPopupToggle = props.setPopupToggle;
    clog("PhotoCloseUp : " + img.url);
    function onClickClose(e) {
        setPopupToggle("");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-picure", className: `popup-boxin ${toggleVal}` },
            React.createElement("div", { className: "page-detail" },
                React.createElement("div", { className: "popup__head" },
                    React.createElement("h1", null, "\uCCA8\uBD80\uD30C\uC77C"),
                    React.createElement("button", { className: "btn btn-close", onClick: (e) => onClickClose(e) },
                        React.createElement("span", { className: "hide" }, "\uB2EB\uAE30"))),
                React.createElement("div", { className: "popup__body" },
                    React.createElement("div", { className: "picimg__view" },
                        React.createElement("img", { src: img.url, alt: img.name }))),
                React.createElement("div", { className: "popup__footer" },
                    React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => setParentFileDelete(img) },
                        React.createElement("span", null, "\uC0AD\uC81C")),
                    React.createElement("button", { type: "button", className: "close", onClick: (e) => onClickClose(e) },
                        React.createElement("span", null, "\uD655\uC778")))))));
}
function EhcPicture(props) {
    //props
    const listSize = props.viewCount;
    const savedFiles = props.savedFiles;
    const onClickAttachFileDelete = props.onClickAttachFileDelete;
    const onClickEhpPicture = props.onClickEhpPicture;
    const [pannelObj, setPannelObj] = useState(null);
    //
    const [curPos, setCurPos] = useState(0);
    //const [listSize, setListSize] = useState(3);
    const ref = useRef(null);
    useEffect(() => {
        setPannelObj(ref.current);
    });
    function next(idx) {
        setCurPos(idx + 1);
    }
    function prev(idx) {
        setCurPos(idx - 1);
    }
    return (React.createElement("div", { className: "ehc__rolling" },
        (curPos > 0) && React.createElement("div", { className: "rolling__left" },
            React.createElement("a", { id: "prev", onClick: (e) => prev(curPos) },
                React.createElement("span", { className: "hide" }, "\uC774\uC804\uC774\uBBF8\uC9C0"))),
        React.createElement("div", { className: "ehc__picture" },
            React.createElement("ul", { ref: ref }, savedFiles.filter((file, idx) => (idx >= curPos) && ((idx < curPos + listSize))).map((img, idx) => (React.createElement("li", { key: "CHECK_IMG" + idx },
                React.createElement("button", { type: "button", className: "btn btn-delete-w", onClick: (e) => onClickAttachFileDelete(img) },
                    React.createElement("span", { className: "hide" }, "\uC0AC\uC9C4\uC0AD\uC81C")),
                React.createElement("a", { className: "picimg", "data-pop": "pop-picure", onClick: (e) => onClickEhpPicture(img) },
                    React.createElement("img", { src: img.url, alt: img.name }))))))),
        ((curPos + listSize) < savedFiles.length) && React.createElement("div", { className: "rolling__right" },
            React.createElement("a", { id: "next", onClick: (e) => next(curPos) },
                React.createElement("span", { className: "hide" }, "\uB2E4\uC74C\uC774\uBBF8\uC9C0")))));
}
//mobile by hjoh 20220829 - mobile pop 추가
function FiledPop(props) {
    const savedFiles = props.savedFiles;
    const setSavedFiles = props.setSavedFiles;
    const cameraRef = useRef(null);
    const galleryRef = useRef(null);
    function onInputCamera(e) {
        cameraRef.current.click();
    }
    function onInputGallery(e) {
        galleryRef.current.click();
    }
    const handleChangeFile = (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("files", file);
        var fileVal = {
            imageId: "INS_" + savedFiles.length,
            name: file.name,
            url: URL.createObjectURL(file),
            type: "INS",
            fileForm: formData,
        };
        if (savedFiles.length <= 9) {
            setSavedFiles([...savedFiles, fileVal]);
            e.target.value = ''; // file name 초기화
        }
        else {
            alert("첨부파일은 10개 까지 가능합니다.");
        }
        const btn = document.getElementById("js-close");
        btn.click();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "pop-fileadd", className: "popup-layer js-layer layer-out popup-bottom page-list-in hidden" },
            React.createElement("h1", { className: "hide" }, "\uCE74\uB4DC\uC2A4\uCE94"),
            React.createElement("div", { className: "popup__body" },
                React.createElement("ul", null,
                    React.createElement("li", null,
                        React.createElement("input", { ref: cameraRef, type: "file", id: "camera", accept: "image/*", capture: "environment", onChange: (e) => handleChangeFile(e), style: { "display": "none" } }),
                        React.createElement("a", { onClick: (e) => onInputCamera(e) },
                            React.createElement("span", { className: "icon-camera" }, "\uC0AC\uC9C4 \uCC0D\uAE30"))),
                    React.createElement("li", null,
                        React.createElement("input", { ref: galleryRef, type: "file", id: "gallery", accept: "image/*", onChange: (e) => handleChangeFile(e), style: { "display": "none" } }),
                        React.createElement("a", { onClick: (e) => onInputGallery(e) },
                            React.createElement("span", { className: "icon-photo" }, "\uC568\uBC94\uC5D0\uC11C \uAC00\uC838\uC624\uAE30"))))),
            React.createElement("div", { className: "popup__footer" },
                React.createElement("button", { id: "js-close", className: "button btn-close js-close" },
                    React.createElement("span", null, "\uB2EB\uAE30"))))));
}
